import { jsx } from "react/jsx-runtime";
import { ApexField } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const BlockApexField = ({
  attrs,
  index
}) => {
  if (!attrs.formData) {
    return null;
  }
  return /* @__PURE__ */ jsx(ApexField, { ...attrs }, index);
};
BlockApexField.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
};
export {
  BlockApexField as default
};
